import type { FC } from "react";
import { Icon } from "../UI/Icon";

interface AlertIconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

export const AlertIcon: FC<AlertIconProps> = (props) => (
  <Icon {...props} variant="outline" viewBox="0 0 20 20 ">
    <path
      d="M2.10474 17.79C1.37474 17.79 0.704736 17.41 0.324736 16.77C-0.0852635 16.1 -0.105264 15.29 0.254736 14.59L6.88474 1.15C7.26474 0.44 7.96474 0 8.74474 0C9.52474 0 10.2347 0.44 10.5947 1.14L17.1947 14.61C17.5547 15.3 17.5247 16.1 17.1147 16.77C16.7347 17.41 16.0647 17.79 15.3347 17.79H2.10474ZM8.74474 1.12C8.38474 1.12 8.06474 1.32 7.88474 1.65L1.25474 15.1C1.06474 15.46 1.07474 15.86 1.27474 16.19C1.46474 16.5 1.76474 16.67 2.10474 16.67H15.3347C15.6747 16.67 15.9847 16.49 16.1647 16.19C16.3647 15.86 16.3747 15.46 16.2047 15.11L9.60474 1.65C9.43474 1.32 9.10474 1.12 8.74474 1.12Z"
      fill="currentColor"
    />
    <path
      d="M8.72474 11.94C8.41474 11.94 8.16474 11.69 8.16474 11.38V6.97C8.16474 6.66 8.41474 6.41 8.72474 6.41C9.03474 6.41 9.28474 6.66 9.28474 6.97V11.38C9.28474 11.69 9.03474 11.94 8.72474 11.94Z"
      fill="currentColor"
    />
    <path
      d="M8.72474 14.47C8.40474 14.47 8.13474 14.21 8.13474 13.89C8.13474 13.57 8.39474 13.3 8.72474 13.3C9.05474 13.3 9.31474 13.56 9.31474 13.89C9.31474 14.22 9.05474 14.47 8.72474 14.47Z"
      fill="currentColor"
    />
  </Icon>
);
